import { encryptPayload } from "@/utils/cryptoUtils";
import { getPublicKey } from "@/api/request-encoding/getPublicKey";

export async function resetPassword({ mobile_number, password }) {
  try {
    const publicKeyPem = await getPublicKey();
    const encryptedPayload = await encryptPayload({ mobile_number, password }, publicKeyPem);

    const res = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/reset_password`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify(encryptedPayload),
      }
    );

    if (!res.ok) {
      const errorData = await res.json();
      return Promise.reject(errorData || "reset password failed");
    }

    return res.json();
  } catch (err) {
    console.error("Reset password encryption/request error:", err);
    return Promise.reject("Encryption or request error");
  }
}
